import React, { useState } from 'react'
import { X } from 'lucide-react'

interface CloseModalProps {
  visible: boolean
  onClose: () => void
  onConfirm: (amount: number, observations: string) => void
  loading?: boolean
}

export const CloseModal: React.FC<CloseModalProps> = ({
  visible,
  onClose,
  onConfirm,
  loading,
}) => {
  const [amount, setAmount] = useState(0)
  const [observations, setObservations] = useState('')

  if (!visible) return null

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    onConfirm(amount, observations)
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-sm p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Cerrar Caja</h2>
          <button onClick={onClose}>
            <X />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm">Monto final (efectivo)</label>
            <input
              type="number"
              step="1"
              value={amount}
              onChange={e => setAmount(Number(e.target.value))}
              className="mt-1 w-full border rounded px-3 py-2"
            />
          </div>
          <div>
            <label className="text-sm">Observaciones</label>
            <textarea
              value={observations}
              onChange={e => setObservations(e.target.value)}
              className="mt-1 w-full border rounded px-3 py-2"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-red-600 text-white rounded py-2 hover:bg-red-500 disabled:opacity-50"
          >
            {loading ? 'Cerrando...' : 'Cerrar Caja'}
          </button>
        </form>
      </div>
    </div>
  )
}
